/* eslint-disable prettier/prettier */
import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import ReactDOM from "react-dom";

import ModelerModalCategoryList from "./modeler-modal-category-list";
import {
  getExtensionElement,
  modifyExtensionElement,
} from "../../../../../util/camundaPropertiesPanelUtils";

function BuildCategoryModal(itens, elementdom, saveCategory, element) {
  ReactDOM.render(
    <ModelerModalCategoryList
      FormComponents={itens}
      saveCategory={saveCategory}
      element={element}
    />,
    elementdom,
  );
}

export default function (group, element, bpmnFactory, translate, modeling) {
  const getValue = function (businessObject) {
    return function (element) {
      const documentations =
          businessObject && businessObject.get("documentation"),
        text =
          documentations && documentations.length > 0
            ? documentations[0].text
            : "";

      return { documentation: text };
    };
  };

  const setValue = function (businessObject) {
    return function (element, values) {
      const newObjectList = [];
      if (
        typeof values.documentation !== "undefined" &&
        values.documentation !== ""
      ) {
        newObjectList.push(
          bpmnFactory.create("bpmn:Documentation", {
            text: values.documentation,
          }),
        );
      }
      return cmdHelper.setList(
        element,
        businessObject,
        "documentation",
        newObjectList,
      );
    };
  };

  const saveCategory = function (element, values) {
    const bo = getBusinessObject(element);

    if (values === null || values === undefined || values.length === 0) return;
    const listCatogy = values.map((v, i) => Object.keys(v)[0]); //[{"2" : true, "name": "some category"}] ==> ["2"]

    //categoria
    let bpmnDocumentation = "";
    for (let idx = 0; idx < values.length; idx++) {
      if (values[idx][listCatogy[idx]] === true) {
        // [{"2" : true }]
        bpmnDocumentation = values[idx].name;
        break;
      }
    }

    const newObjectList = [];

    newObjectList.push(
      bpmnFactory.create("bpmn:Documentation", {
        text: bpmnDocumentation,
      }),
    );

    bo.set("documentation", newObjectList);

    modeling.updateProperties(element, {});
  };

  const saveCategoryProcess = function (element, values) {
    const bo = getBusinessObject(element).processRef;

    if (values === null || values === undefined || values.length === 0) return;
    const listCatogy = values.map((v, i) => Object.keys(v)[0]); //[{"2" : true, "name": "some category"}] ==> ["2"]

    //categoria
    let bpmnDocumentation = "";
    for (let idx = 0; idx < values.length; idx++) {
      if (values[idx][listCatogy[idx]] === true) {
        // [{"2" : true }]
        bpmnDocumentation = values[idx].name;
        break;
      }
    }

    const newObjectList = [];

    newObjectList.push(
      bpmnFactory.create("bpmn:Documentation", {
        text: bpmnDocumentation,
      }),
    );

    bo.set("documentation", newObjectList);

    modeling.updateProperties(element, {});
  };

  const setDescricao = function (element, value) {
    const bo = getBusinessObject(element);
    const descricao = value && value.descricao;
    modifyExtensionElement(
      "descricao",
      descricao,
      element,
      bo,
      bpmnFactory,
      modeling,
    );
  };

  const getDescricao = function (element) {
    const bo = getBusinessObject(element);
    const descricaoValue = getExtensionElement("descricao", bo);
    return {
      descricao: descricaoValue,
    };
  };

  //botao que abre modal de categorias
  const elementDocuButton = {
    id: "documentationButton",
    modelProperty: "documentationButton",
    html:
      '<div class="bpp-field-wrapper" ' +
      ' style="float: right; ">' +
      "<button " +
      'class="add" id="camunda-documentation-list" ' +
      'data-action="listCategories"> ' +
      "<span>+</span>" +
      "</button>" +
      "</div>",

    // eslint-disable-next-line no-empty-function
    get(element, node) {},
    // eslint-disable-next-line no-empty-function
    set(element, values) {},
    listCategories(element, values) {
      const bo = getBusinessObject(element);
      const bpmnDocument = bo.get("documentation");

      const categories = {};

      const itens =
        bpmnDocument && bpmnDocument[0] && bpmnDocument[0].text
          ? Array.from([bpmnDocument[0].text])
          : [];
      for (let idx = 0; idx < itens.length; idx++) {
        categories[itens[idx]] = true;
      }

      const modalCategory = document.createElement("modalCategory");
      BuildCategoryModal(categories, modalCategory, saveCategory, element);
    },
  };

  // Element Documentation
  const elementDocuEntry = entryFactory.textField(translate, {
    id: "documentation",
    label: translate("Category"),
    modelProperty: "documentation",
  });

  const elementDescricaoEntry = entryFactory.textBox(translate, {
    id: "descricao",
    label: translate("Description"),
    modelProperty: "descricao",
  });

  // categoria
  elementDocuEntry.set = setValue(getBusinessObject(element));
  elementDocuEntry.get = getValue(getBusinessObject(element));

  // descricao
  elementDescricaoEntry.set = (el, value) => setDescricao(element, value);
  elementDescricaoEntry.get = (el) => getDescricao(element);

  //só mostra o campo 'documentação' se for bpmn:process ou
  if (is(element, "bpmn:Process")) {
    group.entries.push(elementDocuButton);
    group.entries.push(elementDocuEntry);
    group.entries.push(elementDescricaoEntry);
  }

  const elementDocuPoolParticipantButton = {
    id: "documentationProcessButton",
    modelProperty: "documentationProcessButton",
    html:
      '<div class="bpp-field-wrapper" ' +
      ' style="float: right; ">' +
      "<button " +
      'class="add" id="camunda-process-documentation-list" ' +
      'data-action="listProcessCategories"> ' +
      "<span>+</span>" +
      "</button>" +
      "</div>",
    // eslint-disable-next-line no-empty-function
    get(element, node) {},
    // eslint-disable-next-line no-empty-function
    set(element, values) {},
    listProcessCategories(element, values) {
      const bo = getBusinessObject(element).processRef;
      const bpmnDocument = bo.get("documentation");

      const categories = {};

      const itens =
        bpmnDocument && bpmnDocument[0] && bpmnDocument[0].text
          ? Array.from([bpmnDocument[0].text])
          : [];
      for (let idx = 0; idx < itens.length; idx++) {
        categories[itens[idx]] = true;
      }

      const modalCategory = document.createElement("modalCategory");
      BuildCategoryModal(
        categories,
        modalCategory,
        saveCategoryProcess,
        element,
      );
    },
  };

  let processRef;

  // Process Documentation when having a Collaboration Diagram
  if (is(element, "bpmn:Participant")) {
    processRef = getBusinessObject(element).processRef;

    // do not show for collapsed Pools/Participants
    if (processRef) {
      const processDocuEntry = entryFactory.textBox(translate, {
        id: "process-documentation",
        label: translate("Category"),
        modelProperty: "documentation",
      });

      const processElementDescricaoEntry = entryFactory.textBox(translate, {
        id: "descricao",
        label: translate("Description"),
        modelProperty: "descricao",
      });

      processDocuEntry.set = setValue(processRef);

      processDocuEntry.get = getValue(processRef);

      // descricao
      processElementDescricaoEntry.set = (el, value) =>
        setDescricao(processRef, value);
      processElementDescricaoEntry.get = (el) => getDescricao(processRef);

      group.entries.push(elementDocuPoolParticipantButton);
      group.entries.push(processDocuEntry);
      group.entries.push(processElementDescricaoEntry);
    }
  }
}
